import React from 'react';

import TableRow from './TableRow.jsx';

const TableBody = (props) => {
    let programas = undefined;
    let programasResult = undefined;
    let programasToRender = null;
    let data = props.data;

    if (data) {
        programas = props.data || [];

        let programaIds = programas.map((f) => { return f.ProgramaId });

        programaIds = programaIds.filter((f, indexId, arrayId) => {
            return indexId == arrayId.indexOf(f)
        });

        programasResult = programaIds.map((pid) => {
            let programasFound = programas.filter((p) => { return p.ProgramaId == pid });
            let result = {
                Title: programasFound[0].Programa,
                Funciones: []
            };

            programasFound.forEach((f) => {
                result.Funciones.push({
                    Codigo: f.Funcion,
                    Descripcion: f.Funcion
                });
            });

            return result;
        });

        programasToRender = programasResult.map((result) => {
            return <TableRow Programa={result} />
        });
    }

    return (
        <div className="col-xs-12">
            <ul className="list-unstyled">
                {programasToRender}
            </ul>
        </div>);
}

export default TableBody;